import React from "react";

const Text10 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
          Fält- & Rubrikförklaring
        </p>

      <div className="content-text mt-4">
        
        <p className="heading2">
          Affärsområde/Produktgrupp             
        </p>    
        <p>
          Fyll i om det är meningsfullt för Dig.   
        </p>
        <p className="ms-3" style={{marginBottom:'0px'}}>
          <u>Ex:</u> Restaurang.    
        </p>
        <ol className="ms-3">
          <li className="mt-1"> Lunchmeny </li>
          <li className="mt-1"> A la Carte </li>
          <li className="mt-1"> Take away </li>
        </ol>  


        <p className="heading2 mt-4">
          Erbjudande (Vara eller Tjänst)             
        </p>  
        <p>
          En produkt kan bestå av en eller flera varor och/eller tjänster. Exempelvis är produkten 
          mobiltelefon sammansatt av display, batteri, knappsats, radio, antenn, mjukvara, skal, manual, 
          förpackning, garanti och mycket mer.     
        </p>
        <p>
          <u>Exempel på produkter:</u>   
        </p>
        <p className="ms-3" style={{marginBottom:'0px'}}>
          A - <i>Restaurang - Lunchmeny</i>
        </p>
        <ul className="ms-3">
          <li className="mt-1"> Dagens Lunch_Kött </li>
          <li className="mt-1"> Dagens Lunch_Fisk </li>
          <li className="mt-1"> Dagens Lunch_Vegetarisk </li>
        </ul>  
        <p className="ms-3" style={{marginBottom:'0px'}}>
          B - <i>IT-konsult - Systemutveckling</i> 
        </p>
        <ul className="ms-3">
          <li className="mt-1"> Projektledning  </li>
          <li className="mt-1"> Process- o produktspecifikation </li>
          <li className="mt-1"> Kodning </li>
          <li className="mt-1"> Implementation/driftsättning </li>
          <li className="mt-1"> Dokumentation </li>
          <li className="mt-1"> Användarutbildning </li>
        </ul>  
        <p className="ms-3" style={{marginBottom:'0px'}}>
          C - <i>Taxirörelse</i> 
        </p>
        <ul className="ms-3">
          <li className="mt-1"> Publik transport </li>
          <li className="mt-1"> Färdtjänst </li>
          <li className="mt-1"> Varuleverans </li>
        </ul>  


        <p className="heading2 mt-4">
          Försäljningspris/st.
        </p>
        <p>
          Det pris <i>per styck</i> som du bedöms kunna erhålla - efter rabatter (och extra rabatter …).       
        </p>
        <p> 
          <u> Exempel på enhet: </u> 
        </p>
        <ul>
          <li className="mt-1"> 
            Kan för updragstagare avse ett fast_pris-uppdrag  (Som att tandläkarpraktiken erbjuder blekning, 
            hygienistbehandling, rotfyllning, implantat o s v.)   
          </li>
          <li className="mt-1"> 
            För eventarrangör kan avses per betalande deltagare eller deltagargrupp
          </li>
          <li className="mt-1"> 
            För bensinmacken typiskt per liter bensin
          </li>
        </ul>
        <p>
          Pris avser här <u><i>Din</i></u> kund - <i>inte</i> kundens kund o s v. 
        </p>
        <p>
          <u> Exempel på Ditt försäljningspris </u>
        </p>   
        <p>
          Grossistens försäljningspris till butik 150 kronor. Butikens försäljningspris till konsument 
          300 kronor. Är du grossisten i exemplet skriver du sek 150:-. Är du butik skriver du sek 300:-. 
        </p>
        <p>
          Inga glädjekalkyler utan ett <i>realistiskt</i> pris i relation till marknadens realiteter. 
          Börja med att kolla branschens prisbild. Vad är dyrt? Vad är billigt? Varför? Var jackar Ditt erbjudande 
          naturligt i prisbilden? Varför? 
        </p>
        <p>
          Fråga några relevanta personer vad Ditt erbjudande är värt och: Varför? Kom ihåg att det är inte du i 
          slutänden som sätter priset - det är kunden på marknaden.
        </p>
        <p>
          Vad krävs för att kunna ta ut högre pris? Klarar du det kravet? Söker du volymaffär vill du kanske 
          tvärtom erbjuda rejält sänkt pris. Hur billigt klarar du? Testa! 
        </p>


        <p className="heading2 mt-4">
          Rörlig kostnad/st.
        </p>
        <p>
          <i>Summa</i> kostnader <i>per styck</i> som ökar/minskar i med produktslagets <i>försäljningsvolym</i>.        
        </p>
        <p>
          Exempelvis material, insatsvaror, tillverkning, tillsatser, förpackning, frakt, extra-personal, agentprovision …    
        </p>
        <p>
          Rörliga kostnader uppstår i alla steg fram till kund - inte enbart i tillverkningsprocessen. 
          Från första planering till leverans, underhåll, provision till återförsäljare/agenter och mera.  
        </p>


        <p className="heading2 mt-4">
          Täckningsbidrag
        </p>
        <p>
          Visar hur många kronor som varje <i>såld</i> produkt - efter avdrag för produktens rörliga kostnad - faktiskt 
          bidrar med för att täcka fasta kostnader exempelvis löner till Dig och eventuella anställda. 
        </p>
        <p>
          TB avser alltså här vad <i>varje enskild enhet</i> (per styck) drar in, att täcka företagets övriga fasta 
          kostnadsmassa.   
        </p>
        <p>
          <i><u>Beräknas:</u> Försäljningspris - Rörliga Kostnader = TB.</i>
        </p>
        <p>
          <u>Ex:</u> En produkt säljs till detaljist för 32 kronor. Rörliga kostnader 12 kronor. TB då (32 - 12) = 20 kronor.
        </p>

        <p className="heading2 mt-4">
          Täckningsgrad
        </p>
        <p>
          Visar hur många ören per varje intjänad krona som en <i>såld</i> produkt faktiskt bidrar med - efter avdrag 
          för produktens rörliga kostnader. Alltså vilka produkter som ger <i>bäst bidrag</i> till verksamheten - 
          per intjänad krona.  
        </p>
        <p>
          <i><u>Ex:</u></i> En rörlig kostnad på säg 40% av försäljningspris ger 60% (= 60 öre) kvar av varje krona kunden 
          betalar, till att täcka företagets fasta kostnader. 
        </p>
      
        
        <p className="heading2 mt-4">
          Arbetade tim./st.
        </p>
        <p>
          För Dig som säljer tjänster och tar betalt per nedlagd timme anges tiden från start till genomförd leverans.  
        </p>
        <p>
          Du bör räkna in all tid från förberedelser till genomförd kundlevererans även om du inte kan fakturera allt - 
          för att förstå Dina verkliga kostnader.
        </p>
        <p>
          Uttrycks - som hel eller del av timmar - per levererad produkt. 
        </p>
        <p>
          <i><u>Ex:</u></i> Två timmar skrivs ”2”, halv timme skrivs 0,5 tim, 15 min skrivs 0,25 tim, 10 min skrivs 
          0,17 tim.
        </p>


        <p className="heading2 mt-4">
          Täckningsbidrag/tim.
        </p>
        <p>
          Visar täckningsbidrag i kronor per arbetad <i>hel timme</i> som produktslaget tillför verksamheten.
        </p>


        <p className="heading2 mt-4">
          Årsvolym antal st.
        </p>
        <p>
          Ange det antal enheter/styck av en produkt som du beräknas klara att sälja och leverera under det verksamhetsår 
          du beskriver
        </p>
        <p>
          Här är det <u><i>extra viktigt</i></u> att beräkningsunderlaget är ”sunt”. Fundera … 
        </p>
        <p>
          <i>Ex:</i> Vilka volymer tål marknaden? Hur kan de växa? Hur mycket säljer likvärdiga konkurrenter på årsbasis? 
          Vilken marknadsandel kan du realistiskt nå - och hantera - det året med produktmixen du angett? 
          Varför tror du det?
        </p>


        <p className="heading2 mt-4">
          Årsförsäljning
        </p>
        <p>
          Ett produktslags totala <i>omsättning</i> i kronor det året.
        </p>
        <p>
          <u>Beräknas</u>: (antal enheter x försäljningspris) det året. 
        </p>


        <p className="heading2 mt-4">
          Årstäckningsbidrag
        </p>
        <p>
          Hur mycket av ett produktslags omsättning för året som blir över till att täcka firmans alla fasta kostnader. 
        </p>
        <p>
          <i>Viktigt volymvärde</i> vid lönsamhetsbeslut kring produktmix. 
        </p>
        

      </div>
    </>
  );
}
export default Text10;